import PythonApi from '@/services/PythonApi'

export default {
  list() {
    const params = new URLSearchParams();
    return PythonApi().get('companies', params)
  },
  get (company_id) {
    return PythonApi().get(`companies/${company_id}`)
  },
  post (company) {
    return PythonApi().post('companies', company)
  },
  put (company) {
    return PythonApi().put(`companies/${company.company_id}`, company)
  }
}



// WEBPACK FOOTER //
// ./src/services/CompaniesService.js